module.exports = __webpack_public_path__ + "media/assets/images/blog/ridurre_i_costi-d510a10e8880f25ee5ff05c618c9dce3.png";